@let text = label() || ('Curtir' | transloco);

<button
  type="button"
  [attr.id]="buttonId() || null"
  [class]="buttonClasses"
  [disabled]="disabled()"
  [attr.aria-pressed]="liked()"
  [attr.aria-label]="text"
  [attr.aria-busy]="loading()"
  [zTooltip]="text"
  (click)="onClick()"
>
  @if (loading()) {
    <ngx-skeleton-loader
      class="h-[15px] w-[15px]"
      [theme]="{ width: '100%', height: '100%', borderRadius: '4px', marginBottom: 0 }"
    />
  } @else {
    <ng-icon
      name="svcLike"
      size="15px"
      aria-hidden="true"
    />
  }
  {{ count() || '' }}
</button>
